import { createSlice } from '@reduxjs/toolkit';
import environments from '../../app/environments.js'

export const GLOBAL_ID = 'GLOBAL';
export const DEFAULT_REGISTRATION_KEYS = ['BIG', 'V&VN', 'KABIZ', 'NVVPO'];

const envSlice = createSlice({
    name: 'env',
    initialState: {
    },
    reducers: {
        initialize: (state, action) => {
            const { payload } = action;
            if (!payload || !payload.settings) {
                return;
            }

            const { settings, preview } = payload;
            let { env, portalIdentifier, registrationKeys } = settings;

            if (!portalIdentifier) {
                portalIdentifier = GLOBAL_ID;
            }

            if (['development', 'production'].indexOf(env) === -1) {
                env = 'development';
            }

            if (registrationKeys?.length === 0) {
                registrationKeys = DEFAULT_REGISTRATION_KEYS;
            }

            state.portalIdentifier = portalIdentifier;
            state.hasGlobalId = portalIdentifier === GLOBAL_ID;
            state.settings = environments[env];
            state.registrationKeys = registrationKeys;

            if (preview !== undefined) {
                state.preview = preview;
            }
        },
    },
});

export const { initialize } = envSlice.actions;

export default envSlice.reducer;